/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForDeviceConnectionCountersResponseElements,
    ReportForDeviceConnectionCountersResponseElementsFromJSON,
    ReportForDeviceConnectionCountersResponseElementsFromJSONTyped,
    ReportForDeviceConnectionCountersResponseElementsToJSON,
} from './ReportForDeviceConnectionCountersResponseElements';

/**
 * 
 * @export
 * @interface ReportForDeviceConnectionCountersResponse
 */
export interface ReportForDeviceConnectionCountersResponse {
    /**
     * 
     * @type {Array<ReportForDeviceConnectionCountersResponseElements>}
     * @memberof ReportForDeviceConnectionCountersResponse
     */
    elements: Array<ReportForDeviceConnectionCountersResponseElements> | null;
}

export function ReportForDeviceConnectionCountersResponseFromJSON(json: any): ReportForDeviceConnectionCountersResponse {
    return ReportForDeviceConnectionCountersResponseFromJSONTyped(json, false);
}

export function ReportForDeviceConnectionCountersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceConnectionCountersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': (json['elements'] === null ? null : (json['elements'] as Array<any>).map(ReportForDeviceConnectionCountersResponseElementsFromJSON)),
    };
}

export function ReportForDeviceConnectionCountersResponseToJSON(value?: ReportForDeviceConnectionCountersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': (value.elements === null ? null : (value.elements as Array<any>).map(ReportForDeviceConnectionCountersResponseElementsToJSON)),
    };
}

